import React from 'react';
import Layout from '../../../components/Layout';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';
import { Download } from 'lucide-react';

const IncomeReport = () => {
    // Initial empty state
    // eslint-disable-next-line no-unused-vars
    const [barData, setBarData] = React.useState([
        { name: 'Binary', amount: 4500 },
        { name: 'Direct', amount: 3000 },
        { name: 'Rewards', amount: 2000 },
        { name: 'ROI', amount: 2780 },
        { name: 'Repurchase', amount: 1890 },
    ]);

    React.useEffect(() => {
        // TODO: Fetch income stats
    }, []);

    const COLORS = ['#2563eb', '#8b5cf6', '#f59e0b', '#10b981', '#ef4444'];

    return (
        <Layout>
            <div className="space-y-8 p-1 sm:p-2">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 tracking-tight flex items-center gap-3">
                            <Download className="text-purple-600 rotate-180" size={32} />
                            Income Distribution
                        </h1>
                        <p className="text-gray-500 font-medium tracking-tight">Comprehensive analysis of total payout distributions</p>
                    </div>
                    <button className="w-full sm:w-auto px-6 py-3 bg-white border border-gray-100 text-gray-700 rounded-2xl hover:bg-gray-50 font-black text-xs uppercase tracking-widest flex items-center justify-center gap-2 shadow-sm transition-all active:scale-95">
                        <Download size={18} /> Download CSV Data
                    </button>
                </div>

                <div className="bg-white p-6 sm:p-10 rounded-[2.5rem] shadow-sm border border-gray-100 h-[600px] sm:h-[550px] relative overflow-hidden group">
                    <div className="absolute -left-12 -top-12 w-48 h-48 bg-purple-50 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700" />
                    <div className="relative z-10 flex flex-col h-full">
                        <div className="mb-10">
                            <h3 className="text-lg font-black text-gray-900 uppercase tracking-tight">Payout Categories</h3>
                            <p className="text-xs text-gray-400 font-bold tracking-tight">Breakdown of earnings across various incentive channels</p>
                        </div>
                        <ResponsiveContainer width="100%" height="90%">
                            <BarChart data={barData} layout="vertical" margin={{ top: 5, right: 30, left: 10, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#f1f5f9" />
                                <XAxis type="number" hide />
                                <YAxis
                                    dataKey="name"
                                    type="category"
                                    width={100}
                                    tick={{ fill: '#64748b', fontSize: 13, fontWeight: 700 }}
                                    axisLine={false}
                                    tickLine={false}
                                />
                                <Tooltip
                                    cursor={{ fill: '#f8fafc' }}
                                    contentStyle={{ borderRadius: '1.25rem', border: 'none', boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1)', padding: '1rem' }}
                                    itemStyle={{ fontWeight: 900, fontSize: '0.875rem' }}
                                />
                                <Bar dataKey="amount" fill="#3b82f6" radius={[0, 12, 12, 0]} barSize={45} animationDuration={2000}>
                                    {barData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default IncomeReport;
